import { createApp } from "vue";
import Workspace from "../components/Workspace.vue";
import "../styles/application.css";

const components = { Workspace };
for (const element of document.querySelectorAll("[data-vue-component]")) {
  const component = components[element.dataset.vueComponent];
  if (component) createApp(component, JSON.parse(element.dataset.props || "{}")).mount(element);
}
